module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_karuizawa-d9f746ca98899abf59f40fdaf9c240fa.jpg";